import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ItemClassModel } from './model/item-class.model';
import { RequestData } from 'src/app/common/models/request-data.model';

@Injectable({
  providedIn: 'root'
})
export class ItemClassService {

  constructor(private http: HttpClient) { }

  /**
   * Get list of item classes
   * @param requestData Request parameters
   * @returns Observable with item class list
   */
  getList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/item-class/get', requestData);

  }

  /**
   * Get parent classes for dropdown
   * @param requestData Request parameters
   * @returns Observable with parent class list
   */
  getParentClass(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/item-class/get-super-classes/', requestData);
  }

   getById(id:number): Observable<any> {
     return this.http.post(environment.baseUrl+'/item-class/get/'+id, '');
 
   }
 
    /**
    * 
    * @param itemClassInfo 
    * Calls the update API to insert/update the record
    */
    update(itemClassInfo: ItemClassModel): Observable<any> { 
     if(itemClassInfo.id && itemClassInfo.id !== 0){
       return this.http.post(environment.baseUrl+'/item-class/update', itemClassInfo);
     } else{
       return this.http.post(environment.baseUrl+'/item-class/add', itemClassInfo);
     }
   }
   downloadExcel(requestData: any): Observable<Blob> {
     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
 
     return this.http.post(environment.baseUrl + '/item-class/export-item-class', requestData, { headers, responseType: 'blob' })
       .pipe(
         //catchError(this.handleError)
       );
 
   }
 
     /**
    * 
    * @param areaInfo 
    * Calls the API to delete the record
    */
     delete(itemClassInfo: ItemClassModel): Observable<any>  {
       return this.http.post(environment.baseUrl+'/item-class/delete/'+itemClassInfo.id, itemClassInfo);
     }
    }